import React from "react";

const SagentLogo = ({ className = "w-8 h-8", ...props }) => {
  return (
    <svg
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      {/* Head Band / Outer Frame */}
      <path
        d="M25 40 Q25 18 50 18 Q75 18 75 40"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinecap="round"
      />
      
      {/* Face Plate */}
      <rect
        x="25"
        y="36"
        width="50"
        height="34"
        rx="10"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinejoin="round"
      />
      
      {/* Eyes */}
      <circle cx="40" cy="53" r="4" fill="currentColor" />
      <circle cx="60" cy="53" r="4" fill="currentColor" />
      
      {/* Ear Cups / Headphones */}
      <rect
        x="12"
        y="42"
        width="13"
        height="22"
        rx="6"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinejoin="round"
      />
      <rect
        x="75"
        y="42"
        width="13"
        height="22"
        rx="6"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinejoin="round"
      />
      
      {/* Microphone Arm */}
      <path
        d="M58 70 C58 88 82 88 82 72"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default SagentLogo;
